import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orgObj: {},
  walletObj: {},
  orgDocObj: {},
  directHeaderObj: {},
  singlePaymentObj: {},

  activeObj: {},
  memberObj: [],
  sourceName: "",
  categoryObj: {},
  current: 0,
};

export const objSlice = createSlice({
  name: "obj",
  initialState,
  reducers: {
    setOrgObj: (state, action) => {
      state.orgObj = action.payload;
    },
    setWalletObj: (state, action) => {
      state.walletObj = action.payload;
    },
    setOrgDocObj: (state, action) => {
      state.orgDocObj = action.payload;
    },
    setDirectHeaderObj: (state, action) => {
      state.directHeaderObj = action.payload;
    },
    setActiveObj: (state, action) => {
      state.activeObj = action.payload;
    },
    setMemberObj: (state, action) => {
      state.memberObj = action.payload;
    },
    setSourceName: (state, action) => {
      state.sourceName = action.payload;
    },
    setCategoryObj: (state, action) => {
      state.categoryObj = action.payload;
    },
    setcurrent: (state, action) => {
      state.current = action.payload;
    },
    cleanCurrent: (state) => {
      state.current = 0;
    },
    cleanOrgDocObj: (state) => {
      state.orgDocObj = {};
    },
    cleanWalletObj: (state) => {
      state.walletObj = {};
    },
    cleanOrgObj: (state) => {
      state.orgObj = {};
    },
    clearObj: () => {
      return { ...initialState };
    },
    cleanDirectHeaderObj: (state) => {
      state.directHeaderObj = {};
    },

    setSinglePaymentObj: (state, action) => {
      state.singlePaymentObj = action.payload;
    },
    cleanSinglePaymentObj: (state) => {
      state.singlePaymentObj = {};
    },
  },
});

export default objSlice.reducer;
export const {
  setOrgObj,
  cleanOrgObj,
  setWalletObj,
  cleanWalletObj,
  setOrgDocObj,
  cleanOrgDocObj,
  setDirectHeaderObj,
  cleanDirectHeaderObj,
  setSinglePaymentObj,
  cleanSinglePaymentObj,
  setActiveObj,
  clearObj,
  setMemberObj,
  setSourceName,
  setCategoryObj,
  setcurrent,
  cleanCurrent,
} = objSlice.actions;
